import { API_BASE_URL } from '../config/api';

/** URL فایل‌های user-uploads — same-origin در production با proxy */
export const getUserUploadsUrl = (relativePath) => {
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  if (API_BASE_URL.startsWith('http')) {
    const origin = API_BASE_URL.replace(/\/api\/v\d+\/?$/i, '');
    return `${origin}${path}`;
  }
  return path;
};
